import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useGetDropdownImport(isOpenImport: boolean = false) {
  return useQuery(
    ["dropdown-import"],
    async () => {
      const endpoints: { name: string; url: any }[] = [
        { name: "safraList", url: URL.PLANO_OPERACIONAL.SAFRA_DROPDOWN_ID_EXTERNO },
        { name: "ocupacaoList", url: URL.PLANO_OPERACIONAL.OCUPACAO_DROPDOWN_ID_EXTERNO },
        { name: "unidadeList", url: URL.PLANO_OPERACIONAL.UNIDADE_DROPDOWN_ID_EXTERNO },
        { name: "cenarioList", url: URL.PLANO_OPERACIONAL.OBTER_CENARIOS_DROPDOWN_ID_EXTERNO },
        { name: "classeOperacaoList", url: URL.PLANO_OPERACIONAL.OBTER_CLASSES_OPERACAO_DROPDOWN_ID_EXTERNO },
        { name: "grupoPlanoOperacionalList", url: URL.PLANO_OPERACIONAL.OBTER_GRUPO_PLANO_OPERACIONAL_DROPDOWN_ID_EXTERNO },
      ];

      const requests = endpoints.map(({ name, url }) =>
        http.get(url).then((res) => ({
          name,
          data: res.data || [],
        }))
      );

      const responses = await Promise.all(requests);

      return responses.reduce((acc, { name, data }) => {
        acc[name] = data;
        return acc;
      }, {} as Record<string, any[]>);
    },
    {
      enabled: isOpenImport,
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      keepPreviousData: true,
    }
  );
}


export default useGetDropdownImport;
